<template>
  <div class="user-con-box">
    <user-avatar :img="detail.logo" :text="detail.name"></user-avatar>
    <div class="user-con-content">
      <div class="text ellipsis_line2">
        {{detail.shopName || detail.name}}
        <el-tag class="ml5" type="primary" v-if="detail.shopType==0 ||detail.type==0">
          加盟商
        </el-tag>
        <el-tag class="ml5" type="warning" v-else>
          {{detail.storeType==0?"实体店":"消洗店"}}
        </el-tag>
      </div>
      <div class="id">
        ID:{{detail.shopCode||detail.code}}
      </div>
    </div>
  </div>
</template>

<script>

import UserAvatar from "@/components/base/user-avatar.vue";

export default {
  props:{
    detail:{
      type:Object,
      required:true
    }
  },
  computed:{
    shopType(){
      return this.detail.shopType || this.detail.type;
    }
  },
  name: "shop-box",
  components: {UserAvatar},
  data() {
    return {}
  },
  mixins: [tableBase],
  methods: {},
  mounted() {

  }
}
</script>


<style lang="less" scoped>
.user-con-box{
  display: flex;
  align-items: center;
  .user-con-content{
    flex: 1;
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    .id{
      display: flex;
      align-items: center;
      color: #9e9e9e;
      line-height: 18px;
    }
    .text{
      font-weight: bold;
      line-height: 18px;
    }
  }
}
</style>
